<template>
  <div>
    <list-news
      @editItem="editItem"
      @addNews="addNews"
      @completeRemove="completeRemove"
      v-show="!isShowDetail"
      :key="reRenderKey"
    ></list-news>
    <detail
      v-if="isShowDetail"
      :itemSelected="itemSelected"
      :listEmployee="listEmployee"
      @close="close"
    ></detail>
  </div>
</template>
<script>
import firebase from "@/services/firebase-init.js";
export default {
  created() {
    this.db = firebase.firestore();
    this.getListEmployee();
  },
  data() {
    return {
      db: null,
      isShowDetail: false,
      itemSelected: {},
      reRenderKey: 1,
      listEmployee: [],
    };
  },
  components: {
    ListNews: () => import("./ListNews.vue"),
    Detail: () => import("./Detail.vue"),
  },
  methods: {
    getListEmployee() {
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_USER + bits)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.listEmployee.push(doc.data());
          });
        });
    },
    addNews() {
      this.isShowDetail = true;
    },
    editItem(item) {
      this.isShowDetail = true;
      this.itemSelected = item;
    },
    completeRemove() {
      this.isShowDetail = false;
      this.item = {};
    },
    close() {
      this.isShowDetail = false;
      this.itemSelected = {};
      this.reRenderKey += 1;
    },
  },
};
</script>
